import { ToastProvider } from "./components/Toast";
import { AuthProvider, useAuth } from "./lib/auth";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";

/**
 * There are exactly two screens, gated on one condition, so the app routes on
 * session state rather than on a URL. That keeps deployment simple: the
 * frontend can be served from any static host with no rewrite rules.
 */
function Routes() {
  const { isSignedIn, isRestoring } = useAuth();

  if (isRestoring) {
    return (
      <div className="centered">
        <span className="label">Loading</span>
      </div>
    );
  }
  return isSignedIn ? <DashboardPage /> : <LoginPage />;
}

export function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </ToastProvider>
  );
}
